import { render, staticRenderFns } from "./dice.vue?vue&type=template&id=f9d79e7e&scoped=true&"
import script from "./dice.js?vue&type=script&lang=js&"
export * from "./dice.js?vue&type=script&lang=js&"
import style0 from "./dice.scss?vue&type=style&index=0&id=f9d79e7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d79e7e",
  null
  
)

export default component.exports